import React, { useEffect } from "react";
import { useStore } from "react-redux";
import { FORMS } from "../../helpers/accessModule";
import { LIST_FORMS } from "../../helpers/accessSubmodule";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { MainCard } from "../../components";
import List from "./FormsList";

const Forms = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useStore();

    const { module, submodules } = store.getState().auth.access;

    useEffect(() => {
        if (!module.includes(FORMS)) {
            navigate("/403");
        }
    }, []);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            {submodules.includes(LIST_FORMS) && (
                <Grid item xs={12} md={12} lg={12}>
                    <MainCard title={t("listedesformulaires")}>
                        <List />
                    </MainCard>
                </Grid>
            )}
        </Grid>
    );
};

export default Forms;
